<template>
  <div
    :class="[
      'uf__shell'
    ]"
  >
    {{ label }}
    <div class="uf__content">
      <div
        v-if="form.file.id"
        :style="'background-image: url(' + sourceMedia + ')'"
        class="uf__content__image"
      >
        <div
          class="uf__content__delete"
        >
          <v-icon
            large
            color="rgba(0, 0, 0, 0.40)"
            @click="removeFile(form.file.id)"
          >
            mdi-close-box
          </v-icon>
        </div>
      </div>
      <div
        v-if="!form.file.id"
        v-cloak
        class="uf__content__trigger "
        @drop.prevent="addFile"
        @dragover.prevent
        @click="$refs.upload.click()"
      >
        <div class="uf__content__border">
          <div class="uf__content__icon" />
          <div class="uf__content__text">
            {{ btnText }}
          </div>
        </div>
      </div>
      <input
        id="input_file"
        ref="upload"
        class="uf__content__image__file"
        type="file"
        style="display: none;"
        multiple
        accept="image/jpg,image/jpeg,image/png,image/gif"
        @change="uploadFiles"
      >
      <!--      <div class="uf__error">-->
      <!--        {{ error.files }}-->
      <!--      </div>-->
    </div>
  </div>
</template>
<style lang="scss">
  .uf__content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: calc(100% + 35px);
    margin-left: -17.5px;
    margin-right: -17.5px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    margin-top: 10px;
    padding-bottom: 10px;
    position: relative;
  }
  .uf__content.no_after:after{
    content: none;
  }
  /* .uf__content:after {
    content: '';
    display: block;
    position: absolute;
    top: auto;
    bottom: 0;
    width: calc(100% - 35px);
    left: 17.5px;
    height: 1px;
    background-color: #E2E0EA;
  } */

  .uf__content__image {
    width: 125px;
    margin-left: 17.5px;
    margin-right: 17.5px;
    margin-bottom: 20px;
    height: 125px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: white;
    -webkit-box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.14);
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.14);
    border-radius: 4px;
    position: relative;
    &:hover {
      .uf__content__delete {
        opacity: 0.5;
        &:hover {
          opacity: 1;
        }
      }
    }
    .uf__content__delete {
      opacity: 0.1;
    }
  }
  .uf__content__delete {
    display: inline-block;
    width: 36px;
    height: 36px;
    /* background-image: url('./images/cross-notification.svg'); */
    background-position: center;
    background-repeat: no-repeat;
    background-size: 26px;
    position: absolute;
    top: 4px;
    right: 4px;
    cursor: pointer;
    z-index: 15;
    -webkit-transition: background-image 0.095s ease-in-out;
    -o-transition: background-image 0.095s ease-in-out;
    transition: background-image 0.095s ease-in-out;
  }
  .uf__content__trigger {
    width: calc(100% - 35px);
    margin-left: 17.5px;
    margin-right: 17.5px;
    margin-bottom: 20px;
    height: 125px;
    background-position: center;
    background-repeat: no-repeat;
    background: #F0F0F0;
    -webkit-box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.14);
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.14);
    border: 1px dashed rgba(0, 0, 0, 0.54);
    border-radius: 4px;
    cursor: pointer;
    padding: 10px;
  }
  .uf__content__border {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center
  }

  .uf__shell.not_valid {
    .uf__content__trigger {
      border: 1px dashed #ff5252;
    }
    .uf__error {
      display: block;
    }
  }
  .uf__error {
    display: none;
    width: 100%;
    font-size: 14px;
    line-height: 16px;
    background: #FFDCDC;
    padding: 13px 13px 13px 21px;
    -webkit-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.13);
            box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.13);
    border: 1px dashed #ff5252;
    border-radius: 4px;
    margin-left: 17.5px;
    margin-right: 17.5px;
    z-index: 10;
  }
  @media(max-width: 575px) {
    .uf__trigger {
      width: calc(50% - 35px);
    }
    .uf__image {
      width: calc(50% - 35px);
    }
  }
  @media(max-width: 370px){
    .uf__content {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
     .uf__trigger {
      height: 160px; /* ? */

      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
    .uf__image {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }
</style>
<script>
import { JustpayMediaFileService } from "@/views/loyalty/shared/services/justpay-mediafile-service"

export default {
  name: "UploadPictureFiles",
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '+ Загрузить',
    }
  },
  data: () => ({
    mounted_flag: false,
    form: {
      file: { id: '' },
      image: ''
    },
    // error: {
    //   files: ''
    // },
    justpayMediaFileService: null,
    loader: {
      show: false
    },
  }),
  computed: {
    sourceMedia () {
      if (!this.form.file) return ''
      if (this.form.file.id) {
          return `data:image/jpeg;base64,${this.form.image}`
      } else {
        return ''
      }
    },
    // fileName () {
    //   if (this.form.file) {
    //     return this.form.file.name
    //   } else {
    //     return ''
    //   }
    // },
    // isUploaded () {
    //   if (!this.value) return false
    //   return !!this.value.id
    // }
  },
  watch: {
    value: function () {
      this.init()
    }
  },
  beforeMount () {
    this.justpayMediaFileService = new JustpayMediaFileService()
  },
  mounted: function () {
    this.init()
  },
  methods: {
    async init () {
      console.log('init this.value', this.value)
      if (this.value) {
          this.form.file.id = this.value
          this.form.image = await this.justpayMediaFileService.getPictureFile(this.value)
      }
    },
    async addFile (e) {
      console.log('addFile')
      const droppedFiles = e.dataTransfer.files
      if (!droppedFiles) return
        await this.uploadFiles({ target: { file: [[...droppedFiles][0]] } })
    },
    async removeFile (item) {
      console.log('removeFile this.form.file', this.form.file)
      this.form.file.id = null
      this.$emit('input', null)
      // await this.justpayMediaFileService.deletePictureFile(this.value)
    },
    processFile: function (file) {
      console.log('processFile', file)
      if (file) {
        return true
        var pattern = /(image.jpg|image.jpeg|image.png)/
        if (!file.type.match(pattern)) {
          return false
        } else {
          return true
        }
      }
    },
    async uploadFiles (event) {
      console.log('uploadFiles', event)
      const file = event.target.files[0]
        if (file && this.processFile(file)) {
          this.loader.show = true
          const response = await this.justpayMediaFileService.uploadPictureFile(file)
              document.getElementById("input_file").value = ""
              if (response.error) {
                this.$store.commit("snackbar", "Ошибка при сохранении данных")
              } else {
                this.form.file = response.data[0]
                this.form.image = this.form.file.base64
                console.log('this.form.file', this.form.file)
                this.$emit('input', this.form.file.id)
              }
              this.loader.show = false
        } else {
          // this.error.files = "Не удалось загрузить фотографию"
        }
    }
  }
}
</script>
